exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles--Badge__2qB0i{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;font-size:10px;width:24px;height:24px;background-color:#dae1e8;border-radius:50%;text-transform:uppercase}.styles--success__8SX-U{background-color:#f1f8eb;color:#82c04b}.styles--danger__15vfo{background-color:#fceceb;color:#e35248}.styles--info__1IE2P{background-color:#e3f5ff;color:#0aa4ff}.styles--draft__3MzyD{background:#7d8895;color:#ffffff}.styles--typeRect__nchnU{font-size:13px;line-height:16px;height:auto;width:auto;padding:4px 10px;border-radius:2px;min-width:50px;min-height:8px;font-weight:400}.styles--large__gOKfX{padding:8px}.styles--medium__2Yl4h{padding:4px}\n", ""]);

// exports
exports.locals = {
	"Badge": "styles--Badge__2qB0i",
	"badge": "styles--Badge__2qB0i",
	"success": "styles--success__8SX-U",
	"danger": "styles--danger__15vfo",
	"info": "styles--info__1IE2P",
	"draft": "styles--draft__3MzyD",
	"typeRect": "styles--typeRect__nchnU",
	"large": "styles--large__gOKfX",
	"medium": "styles--medium__2Yl4h"
};